import { Icon } from '../icon';
import type { IconProps } from '../icon';

export function IconCaretDownMd(props: IconProps) {
	return (
		<Icon {...props}>
			<path
				fill="none"
				stroke="currentColor"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2"
				d="m16 10l-4 4l-4-4"
			/>
		</Icon>
	);
}
